<h2 mat-dialog-title>Lock integration?</h2>
<mat-dialog-content>
  <p> 
    Select a lock reason from the presets below, or custom for a custom reason.
  </p>
  
  <mat-form-field>
    <mat-label>Lock Reason</mat-label>
    <mat-select 
        [(ngModel)]="selectedLockReason"
        (selectionChange)="onLockReasonChange($event)">
        @for (lockReasonPreset of lockReasonPresets; track lockReasonPreset) {
            <mat-option [value]="lockReasonPreset">{{lockReasonPreset}}</mat-option>
        }
    </mat-select>
  </mat-form-field>

  <br/>

  @if (customLockReasonSelected()) {
    <mat-form-field>
        <mat-label>Custom Lock Reason</mat-label>
        <span matTextPrefix>CUST: </span>
        <input matInput
            [(ngModel)]="customLockReason"/>
    </mat-form-field>
  }

</mat-dialog-content>
<mat-dialog-actions>
  <button matButton [mat-dialog-close]>Cancel</button>
  <button matButton [mat-dialog-close]="getLockReason()">Lock Integration</button>
</mat-dialog-actions>